<template>
    <div>
        <div class="files_box">
            <div class="file_item" v-for="(item, i) in fileList" :key="i + '123'" v-loading="loading[i]" element-loading-text="下载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <div class="file_area file_progress" v-if="item.type">
                    <div class="file">
                        <img v-if="typeJudge(item, 'bmp,jpg,jpeg,png,gif,pcx,tga,exif,fpx,svg,psd,cdr,pcd,dxf,ufo,eps,ai,raw,WMF,webp,apng')"  alt="">
                        <img v-else-if="typeJudge(item, 'wmv,mpeg,mp4,m4v,mov,asf,flv,f4v,rmvb,rm,3gp,vob,mkv')" src="../../assets/images/ico/ic_video.png" alt="">
                        <img v-else-if="typeJudge(item, 'doc,docx')" src="../../assets/images/ico/ic_word.png" alt="">
                        <img v-else-if="typeJudge(item, 'ppt,pptx,pptm')" src="../../assets/images/ico/ic_ppt.png" alt="">
                        <img v-else-if="typeJudge(item, 'pdf')" src="../../assets/images/ico/ic_pdf.png" alt="">
                        <img v-else-if="typeJudge(item, 'xlsx,xls')" src="../../assets/images/ico/ic_excel.png" alt="">
                        <img v-else src="../../assets/images/ico/ic_other.png" alt="">
                    </div>
                    <div class="file_msg">
                        <p class="file_name" :title="item.name">{{item.name}}</p>
                        <p class="file_size">{{fileSizeForm(item.size)}}</p>
                    </div>
                    <div class="del_close" v-if="item.hasOwnProperty('size')">
                        <i class="el-icon-close" @click="delFile(item,i)"></i>
                    </div>
                    <el-progress :percentage="percentage[i]"></el-progress>
                </div>
                <div class="file_area" v-else>
                    <div class="file">
                        <img v-if="typeJudge(item, 'bmp,jpg,jpeg,png,gif,pcx,tga,exif,fpx,svg,psd,cdr,pcd,dxf,ufo,eps,ai,raw,WMF,webp,apng')" @click="viewFile(item, 'img')" :src="item.hasOwnProperty('size') ? item.response.data.file_addr : item" alt="">
                        <img v-else-if="typeJudge(item, 'wmv,mpeg,mp4,m4v,mov,asf,flv,f4v,rmvb,rm,3gp,vob,mkv')" @click="viewFile(item, 'video')" src="../../assets/images/ico/ic_video.png" alt="">
                        <img v-else-if="typeJudge(item, 'doc,docx')" src="../../assets/images/ico/ic_word.png" alt="">
                        <img v-else-if="typeJudge(item, 'ppt,pptx,pptm')" src="../../assets/images/ico/ic_ppt.png" alt="">
                        <img v-else-if="typeJudge(item, 'pdf')" src="../../assets/images/ico/ic_pdf.png" alt="">
                        <img v-else-if="typeJudge(item, 'xlsx,xls')" src="../../assets/images/ico/ic_excel.png" alt="">
                        <img v-else src="../../assets/images/ico/ic_other.png" alt="">
                    </div>
                    <div class="file_msg" v-if="!item.hasOwnProperty('size')">
                        <p class="file_name" v-if="item.split('/')[item.split('/').length - 1].indexOf('%2') >= 0" :title="getFileName(item)">{{getFileName(item)}}</p>
                        <p class="file_name" v-else :title="item.split('/')[item.split('/').length - 1]">{{item.split('/')[item.split('/').length - 1]}}</p>
                    </div>
                    <div class="file_msg" v-else>
                        <p class="file_name" :title="item.name">{{item.name}}</p>
                        <p class="file_size" v-if="item.hasOwnProperty('size')">{{fileSizeForm(item.size)}}</p>
                    </div>
                    <div class="download_btn" v-if="download != 'false' && $store.state.type == 'pc'">
                        <i class="el-icon-download" @click="downloadFile(item, i)"></i>
                    </div>
                    <div class="del_close" v-if="type != 'log'">
                        <i class="el-icon-close" @click="delFile(item,i)"></i>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="downloadAll" v-if="type == 'log' && download != 'false' && $store.state.type == 'pc'">
            <span @click="downloadFileAll(fileList)">下载全部附件</span>
        </div>
        <div class="view_area" v-show="viewData.show" @click.self="closeView">
            <div class="view_box">
                <img :src="viewData.url" alt="" v-show="viewData.type == 'img'" >
                <video :src="viewData.url" v-show="viewData.type == 'video'" controls autoplay></video>
                <div class="close" @click="closeView">
                    <i class="el-icon-circle-close"></i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'file',
    data() {
        return {
            viewData: {},
            fileSize: 0,
            loading: [],
            percentage: [],
            timer: []
        }
    },
    watch: {
        fileList: function(nF) {
            for(let i=0; i<nF.length; i++) {
                if(nF[i].type && i == nF.length - 1) {
                    this.percentage[i] = this.percentage[i] || 0;
                    this.percentageAdd((nF[i].size || 1200000000)/12000000/96, i);
                }else if(nF[i].response){
                    this.percentage[i] = 100;
                }
            }
        }
    },
    props: ['fileList', 'type', 'download'],
    created() {
    },
    methods: {
        percentageAdd(time, i) {
            if(this.percentage[i] < 96) {
                this.timer[i] = setTimeout(() => {
                    this.$set(this.percentage, i, this.percentage[i]+1);
                    this.percentageAdd(time, i);
                }, time * 1000)
            }else{
                return;
            }

        },
        fileSizeForm(size) {
            if(size/1024 < 1024) {
                return (size/1024).toFixed(2) + 'KB';
            }else{
                return (size/1024/1024).toFixed(2) + 'M';
            }
            
        },
        viewFile(url, type) {
            this.viewData = {
                url: url.size ? url.response.data.file_addr : url,
                type: type,
                show: true
            }
        },
        getFileName(file) {
            if(file.split('/')[file.split('/').length - 1].match(/_(\S*)\?/)) {
                return this.decodeUrl(file.split('/')[file.split('/').length - 1].match(/_(\S*)\?/)[1])
            }else{
                return this.decodeUrl(file.split('/')[file.split('/').length - 1].match(/2F(\S*)\?/)[1].split('2F')[1])
            }
        },
        typeJudge(file, type) {
            let url;
            if(file.response) {
                url = file.response.data.file_addr;
            }else if(file.type) {
                url = file.name;
            }else{
                url = file;
            }
            url = this.decodeUrl(url);
            let fileType = url.split('?')[0];
            fileType = fileType.split('.')[fileType.split('.').length - 1];
            fileType = fileType.toLowerCase();
            if(type.search(fileType) != -1) {
                return true;
            }
            return false;
        },
        decodeUrl(url) {  //中文特殊字符解码
            try {
                decodeURIComponent(url);
                return decodeURIComponent(url);
            } catch (error) {
                return url; // 解码失败，字符串无法被解码
            }
        },
        closeView() {
            this.viewData = {
                url: '',
                type: '',
                show: false
            }
        },
        downloadFile(file, i) {
            this.$set(this.loading, i, true);
            let link = document.createElement("a");
            let url = file.response ? file.response.data.file_addr : file; //codeIMG  要下载的路径
            // 这里是将url转成blob地址，cache: "no-cache" 不使用缓存策略，使用缓存下载alioss文件会出现cors问题
            fetch(url, {
                cache: "no-cache"
            })
                .then((res) => res.blob())
                .then((blob) => {
                    
                    // 将链接地址字符内容转变成blob地址
                    link.href = window.URL.createObjectURL(blob);
                    if(url.split('/')[url.split('/').length - 1].indexOf('%2F') >= 0) {  //去除 %2F(/)和文件名?后面带的参数
                        link.download = this.decodeUrl(url.split('/')[url.split('/').length - 1].match(/_(\S*)\?E/)[1]);
                    }else{
                        link.download = url.split('/')[url.split('/').length - 1];
                    }
                    
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(link.href);
                    setTimeout(() => {
                        this.$set(this.loading, i, false);
                    }, 1500)
                    
                }).catch(() => {
                    this.$message.warning('文件下载失败，请稍后重试!');
                    this.$set(this.loading, i, false);
                });
        },
        downloadFileAll(file) {
            if(this.loading[0]) return;
            for(let i=0; i<file.length; i++) {
                this.$set(this.loading, i, true);
                this.downloadFile(file[i], i);
            }
        },
        delFile(file,i) {
            clearTimeout(this.timer[i]);
            this.percentage.splice(i, 1);
            this.$emit('delFile', file, i);
        }
    }
}
</script>
<style lang="less" scoped>
    .files_box{
        .flexLayout(flex-start, flex-start);
        .file_item{
            position: relative;
            width: 150px;
            height: 40px;
            padding: 10px;
            margin: 10px 10px 10px 0;
            border-radius: 3px;
            border: 1px solid #ddd;
            line-height: 1.3;
            cursor: pointer;
            .file_area{
                .flexLayout(flex-start);
                flex-wrap: nowrap;
                width: 100%;
                &.file_progress{
                    .el-progress {
                        width: 110%;
                        position: absolute;
                        bottom: -15px;
                        left: 4px;
                    }
                }
            }
            .download_btn{
                position: absolute;
                bottom: 5px;
                right: 5px;
                width: 20px;
                height: 20px;
                font-size: 18px;
                color: @colorBlue;
                // display: none;
            }
            &:hover{
                .download_btn{
                    display: block;
                }
            }
            
            .file{
                width: 40px;
                height: 40px;
                margin-right: 10px;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
            .file_msg{
                width: 100px;
                overflow: hidden;
                p{
                    margin: 5px 0;
                    &.file_name{
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    &.file_size{
                        color: #999;
                        font-size: 12px;
                    }
                }
            }
            .del_close{
                position: absolute;
                top: 1px;
                right: 1px;
                width: 16px;
                height: 16px;
                line-height: 16px;
                font-size: 14px;
                text-align: center;
                color: #999;
                border-radius: 50%;
            }
        }
    }
    .downloadAll{
        color: @colorBlue;
        span{
            cursor: pointer;
        }
    }
    .view_area{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        z-index: 3000;
        .view_box{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 500px;
            height: 500px;
            img, video{
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
            .close{
                position: absolute;
                top: -22px;
                right: -18px;
                font-size: 32px;
                cursor: pointer;
                color: #9aa;
            }
            @media (max-width:600px) {
                width: 88%;
                height: 80vh;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/file/file-show.vue